import type { UserCapability } from '@joyful/utils'
import { useHasUserCapability } from '../hooks/useHasUserCapability'

export interface RestrictToCapabilityProps {
  capability: UserCapability | Array<UserCapability>
  children: React.ReactNode
  fallback?: React.ReactNode
}

export function RestrictToCapability({
  capability,
  children,
  fallback = null,
}: RestrictToCapabilityProps) {
  const hasCapability = useHasUserCapability()
  const capabilities = Array.isArray(capability) ? capability : [capability]
  return capabilities.some((capability) => {
    return hasCapability(capability)
  })
    ? children
    : fallback
}
